export enum EnterpriseSize {
  MICRO = 0,
  SMALL = 1,
  MEDIUM = 2,
  LARGE = 3
}

export const EnterpriseSizeMap: Record<EnterpriseSize, string> = {
  [EnterpriseSize.MICRO]: '0~20人',
  [EnterpriseSize.SMALL]: '20~50人',
  [EnterpriseSize.MEDIUM]: '50~100人',
  [EnterpriseSize.LARGE]: '100人以上'
}
